<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="fmhd"><b>ACKNOWLEDGMENTS</b></p>
<p class="noindent">If anyone needs an acknowledgment, it’s my husband. I don’t remember ever before making such a mess and taking over the whole house when working on a book or art project. Granted, a book is comprised of several mini-projects, but still! He’s never said a word, raised an eyebrow, or tripped over anything (like I have). I doubt he imagined this when he said, “I do.” 50 years ago. Thank you for being you. You are my density.</p>
<p class="noindent">Profound thanks to Amy Barrett-Daffin and Todd Hensley for partnering with me again to tell the world that TAP is back! It’s been a wonderful working relationship of over ten years. Working with Amy, Gailen Runge, Roxane Cerda, April Mostek, Helen Frost, and Katie Van Amburg is like coming home again. And thanks to my new-to-me C&amp;T Publishing family members, Liz Aneloski, Lynn Ford, Tristan Gallagher, Estefany Gonzalez, Lauren Herberg, Betsy La Honta, Linda Johnson, Tim Manibusan, and Jennifer Warren, for all their help in bringing this book to life in the best possible way.</p>
<p class="noindent">Major thanks to all of my contributors who enrich the content and eye candy in this book with their own unique style. I appreciate you sharing your time and talent with my readers and me.</p>
<p class="noindent">From the newest family member, granddaughter Olivia, to my oldest son, Brian, and everyone in between, thank you for the joy you bring me and for helping me keep my wings aloft all these years. A special thank-you to my first and closest friend, my sister, Katie.</p>
<p class="image"><img alt="" src="images/pg4_1.jpg"/></p>
<p class="image"><img alt="" src="images/pg6_1.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_acknowledgments.vue?420d2a48